import { getCloudinaryUrl } from '@pendwa/common/utils/getCloudImageUrl.js';
import clsx from 'clsx';
import React from 'react';
import { Helmet } from 'react-helmet';
import { FragmentPageEntryPersonFragment } from '../../../../../../../generated/graphql.js';

export const HeroPersonImage: React.FC<{
  item: FragmentPageEntryPersonFragment;
}> = (props) => {
  const image_url = getCloudinaryUrl({
    path: props.item.image_on_view?.path ?? props.item.fallback_image_path,
    aspect_ratio: 1,
    width: 300,
  });

  return (
    <div className="relative">
      <div className="aspect-square">
        <Helmet>
          <link rel="preload" as="image" href={image_url} />
        </Helmet>
        <img
          className={clsx('rounded-xl object-cover object-center shadow-2xl')}
          src={image_url}
          alt={`${props.item.name} profile image`}
        />
      </div>
    </div>
  );
};
